agneta.directive('EcAccountMember',function($mdDialog,$location, Role_Account_Manager) {
  var vm = this;
  var shared = {
    $mdDialog: $mdDialog,
    $location: $location,
    vm: vm,
    Role_Account_Manager: Role_Account_Manager
  };
  require('account/member/topup.module')(shared);
  require('account/member/usage.module')(shared);

  vm.$on('account-loaded',function(event, account){
    onAccount(account);
  });

  if(vm.viewAccount){
    onAccount(vm.viewAccount);
  }

  function onAccount(account){
    //console.log(account);
    var member = account.role.member;

    if(!member){
      return;
    }
    vm.loading = true;

    Role_Account_Manager.memberGet({
      accountId: vm.viewAccount.id
    })
      .$promise
      .then(function(result){
        vm.member = result;
        vm.usage.load();
      })
      .finally(function(){
        vm.loading = false;
      });


  }


});
